import React from "react"

import { connect } from 'react-redux';

import {
    Card, CardBlock, CardTitle,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Input,
    Badge,
    Row,Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';

import Menu from './menu.js';

class Facturacion extends React.Component{

	constructor(props){
		super(props);

		this.state={

		}
	}

	render(){
		return(

			<Menu props={this.props}/>

			)
	}

}


export default Facturacion;


// WEBPACK FOOTER //
// ./src/views/facturacion/principal.js